import { Children, useEffect, useState } from 'react';
import { IPillsContainerWidget } from './pillsContainerWidget.models';
import { Tab, TabsContainer } from './pillsContainerWidget.style';
import Widgets from '../Widgets/widgets';
import { trackLink } from '@vfit/shared/data-access';
import { getParamsInUrl } from '@vfit/consumer/data-access';

// const pillsContainerWidget = ({ tabs, procucts, setR }: IPillsContainerWidget) => {
const pillsContainerWidget = ({ tabs, procucts }: IPillsContainerWidget) => {
  const [selIndex, setSelIndex] = useState<number>(0);

  const onClickTab = (index: number) => {
    // setR ? setR(index?.toString()) : null;
    trackLink(tabs[index]?.label);
    setSelIndex(index);
  };
  const params = getParamsInUrl('pill');
  useEffect(() => {
    if (params) {
      const index = tabs.findIndex((tab) => tab.label.toLowerCase() === params.toLowerCase());
      if (index !== -1) {
        setSelIndex(index);
      }
    }
  }, [params]);

  return (
    <>
      <TabsContainer>
        {Children.toArray(
          tabs.map((tab, index) => (
            <Tab selected={index === selIndex} onClick={() => onClickTab(index)}>
              {tab.label}
            </Tab>
          ))
        )}
      </TabsContainer>
      {tabs[selIndex]?.widgets && (
        <Widgets widgets={tabs[selIndex]?.widgets} productsAll={procucts} />
      )}
    </>
  );
};

export default pillsContainerWidget;

